import { Basemap, GRAPHIC_HEIGHT, GRAPHIC_WIDTH, GraphicInput, renderGlsnGraphic } from './glsnGraphic';

export type { GraphicInput } from './glsnGraphic';

let basemapPromise: Promise<Basemap> | null = null;

/** Bundled boundary data served from /basemap (same origin, no API key). */
export function loadBasemap(): Promise<Basemap> {
  if (!basemapPromise) {
    basemapPromise = fetch(`${process.env.PUBLIC_URL || ''}/basemap/glsn-basemap.json`)
      .then((res) => {
        if (!res.ok) throw new Error(`Basemap failed to load (${res.status})`);
        return res.json();
      })
      .catch((error) => {
        basemapPromise = null;
        throw error;
      });
  }
  return basemapPromise;
}

/** Expected logo asset: frontend/public/glsn-logo.png. Resolves null if missing so the drawn wordmark is used. */
export const LOGO_URL = `${process.env.PUBLIC_URL || ''}/glsn-logo.png`;
let logoPromise: Promise<HTMLImageElement | null> | null = null;
export function loadLogo(): Promise<HTMLImageElement | null> {
  if (!logoPromise) {
    logoPromise = new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img.naturalWidth > 0 ? img : null);
      img.onerror = () => resolve(null);
      img.src = LOGO_URL;
    });
  }
  return logoPromise;
}

export async function renderDiscussionGraphicCanvas(input: GraphicInput) {
  const [basemap, logo] = await Promise.all([loadBasemap(), loadLogo()]);
  const canvas = document.createElement('canvas');
  canvas.width = GRAPHIC_WIDTH;
  canvas.height = GRAPHIC_HEIGHT;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Canvas is not available');
  renderGlsnGraphic(context, input, basemap, logo);
  return canvas;
}

export async function downloadDiscussionGraphic(input: GraphicInput) {
  const canvas = await renderDiscussionGraphicCanvas(input);
  const name = input.mdNumber ? `glsn-md-${String(input.mdNumber).padStart(4, '0')}` : input.title.replace(/[^a-zA-Z0-9]+/g, '-').replace(/^-|-$/g, '') || 'glsn-discussion';
  const link = document.createElement('a');
  link.download = `${name}.png`;
  link.href = canvas.toDataURL('image/png');
  link.click();
}
